import { useState, useEffect, useRef } from "react";
import { MoreVertical } from "lucide-react";

export function ProjectDropdown({ project, onDelete }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={ref}>
      <button
        className="p-2 rounded-full hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        aria-haspopup="true"
        aria-expanded={isOpen}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen((open) => !open);
        }}
      >
        <MoreVertical className="w-5 h-5 text-gray-600" />
        <span className="sr-only">More options</span>
      </button>

      <div
        className={`absolute right-0 mt-2 w-28 bg-white border border-gray-200 rounded-md shadow-lg z-10 transition-opacity duration-150
          ${
            isOpen
              ? "opacity-100 visible"
              : "opacity-0 invisible pointer-events-none"
          }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          type="button"
          onClick={() => {
            alert(`Edit ${project.name}`);
            setIsOpen(false);
          }}
        >
          Edit
        </button>
        <button
          className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-100"
          type="button"
          onClick={() => {
            setIsOpen(false);
            if (onDelete) onDelete(); // opens modal now
          }}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
